import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserCog, Check } from "lucide-react";
import api from "../lib/api";
import { useRoastLitConfig } from "../lib/verdictly";

export default function ReviewerProfile() {
  const cfg = useRoastLitConfig();
  const navigate = useNavigate();
  const [profile, setProfile] = useState({ gender: null, age_band: null, region: null, profession: null });
  const [saving, setSaving] = useState(false);
  const attrs = cfg?.audience || {};

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/reviewer/profile");
        if (!r.data.exists && !r.data.gender) return;
        setProfile({ gender: r.data.gender, age_band: r.data.age_band, region: r.data.region, profession: r.data.profession });
      } catch (e) {}
    })();
  }, []);

  const pick = (attr, opt) => setProfile((p) => ({ ...p, [attr]: p[attr] === opt ? null : opt }));

  const save = async () => {
    setSaving(true);
    try {
      await api.post("/reviewer/profile", profile);
      toast.success("Profile saved — matching you to tasks now.");
      navigate("/app/review");
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };

  if (!cfg) return <div className="text-zinc-400">Loading…</div>;

  return (
    <div className="max-w-xl" data-testid="reviewer-profile">
      <div className="flex items-center gap-2 text-brand mb-2"><UserCog size={20} /><span className="text-xs tracking-widest uppercase font-bold">Reviewer setup</span></div>
      <h1 className="font-heading font-bold uppercase tracking-tighter text-4xl">Your reviewer profile</h1>
      <p className="text-zinc-400 mt-2 mb-6">This is how we match you to tasks — especially Targeted ones that pay more. Honest answers get you the best-fit panels.</p>

      <div className="rounded-xl border border-white/10 bg-zinc-900/60 p-6 space-y-5">
        {Object.entries(attrs).map(([attr, def]) => (
          <div key={attr}>
            <div className="text-xs tracking-widest uppercase text-zinc-400 font-bold mb-2">{def.label}</div>
            <div className="flex flex-wrap gap-2">
              {Object.entries(def.options).map(([opt, label]) => (
                <button key={opt} data-testid={`prof-${attr}-${opt}`} onClick={() => pick(attr, opt)}
                  className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${profile[attr] === opt ? "border-brand bg-brand/10 text-white" : "border-white/10 text-zinc-400 hover:border-white/25"}`}>
                  {label}
                </button>
              ))}
            </div>
          </div>
        ))}
        <button data-testid="save-profile-btn" onClick={save} disabled={saving}
          className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-brand hover:bg-brand-hover text-black font-bold transition-colors disabled:opacity-50">
          {saving ? "Saving…" : <>Save & find tasks <Check size={16} /></>}
        </button>
      </div>
    </div>
  );
}
